import {
  FORM_FIELD_TEXT,
  FORM_FIELD_TEXTAREA,
  FORM_FIELD_MULTI_SELECT,
} from '@developer/config';

export const FIELD_DEV_DASHBOARD_EDIT_APP_NAME = 'devDashboardEditAppName',
  FIELD_DEV_DASHBOARD_EDIT_APP_SHORT_DESCR = 'devDashboardEditAppShortDescr',
  FIELD_DEV_DASHBOARD_EDIT_APP_TYPE = 'devDashboardEditAppType',
  FIELD_DEV_DASHBOARD_EDIT_APP_CATEGORY = 'devDashboardEditAppCategory',
  FIELD_DEV_DASHBOARD_EDIT_APP_WORK_WITH = 'devDashboardEditAppWorkWith',
  //
  devDashboardEditAppFields = {
    applicationName: {
      id: FIELD_DEV_DASHBOARD_EDIT_APP_NAME,
      name: FIELD_DEV_DASHBOARD_EDIT_APP_NAME,
      isRequired: true,
      labelContent: 'form_dashboard_app_name',
      ui: {
        type: FORM_FIELD_TEXT,
        validationMessage: 'form_dashboard_app_name_validation_empty',
      },
      validations: {
        required: true,
        minLength: 2,
        pattern: /[^\s]/,
      },
    },
    applicationShortDescr: {
      id: FIELD_DEV_DASHBOARD_EDIT_APP_SHORT_DESCR,
      name: FIELD_DEV_DASHBOARD_EDIT_APP_SHORT_DESCR,
      isRequired: true,
      labelContent: 'form_dashboard_app_descr',
      ui: {
        type: FORM_FIELD_TEXTAREA,
        validationMessage: 'form_dashboard_app_descr_validation_empty',
      },
      validations: {
        required: true,
        minLength: 15,
        pattern: /[^\s]/,
      },
    },
    applicationType: {
      id: FIELD_DEV_DASHBOARD_EDIT_APP_TYPE,
      name: FIELD_DEV_DASHBOARD_EDIT_APP_TYPE,
      isRequired: true,
      labelContent: 'form_dashboard_app_type',
      ui: {
        type: FORM_FIELD_MULTI_SELECT,
        validationMessage: 'form_dashboard_edit_type_validation_empty',
      },
      validations: {
        required: true,
      },
    },
    applicationCategory: {
      id: FIELD_DEV_DASHBOARD_EDIT_APP_CATEGORY,
      name: FIELD_DEV_DASHBOARD_EDIT_APP_CATEGORY,
      isRequired: true,
      labelContent: 'form_dashboard_app_category',
      ui: {
        type: FORM_FIELD_MULTI_SELECT,
        validationMessage: 'form_dashboard_edit_category_validation_empty',
      },
      validations: {
        required: true,
      },
    },
    applicationWorkWith: {
      id: FIELD_DEV_DASHBOARD_EDIT_APP_WORK_WITH,
      name: FIELD_DEV_DASHBOARD_EDIT_APP_WORK_WITH,
      isRequired: true,
      labelContent: 'form_dashboard_app_solution',
      ui: {
        type: FORM_FIELD_MULTI_SELECT,
        validationMessage: 'form_dashboard_edit_solution_validation_empty',
      },
      validations: {
        required: true,
      },
    },
  };
